export const SLIME_TYPES = {
  FIRE: 'red-slime',
  WATER: 'blue-slime',
  PLANT: 'green-slime',
  SMOG: 'black-slime',
  PURPLE: 'purple-slime',
  SOIL: 'brown-slime',
  TIME: 'time-slime',
} as const;

export type SlimeType = (typeof SLIME_TYPES)[keyof typeof SLIME_TYPES];

export const ALL_SLIME_TYPES: SlimeType[] = [
  SLIME_TYPES.FIRE,
  SLIME_TYPES.WATER,
  SLIME_TYPES.PLANT,
  SLIME_TYPES.SMOG,
  SLIME_TYPES.PURPLE,
  SLIME_TYPES.SOIL,
];

export const getSlimeColor = (type: SlimeType): string => {
  switch (type) {
    case SLIME_TYPES.FIRE:
      return '#FF6B6B';
    case SLIME_TYPES.WATER:
      return '#4ECDC4';
    case SLIME_TYPES.PLANT:
      return '#6BB951';
    case SLIME_TYPES.SMOG:
      return '#4A4458';
    case SLIME_TYPES.PURPLE:
      return '#DDA0DD';
    case SLIME_TYPES.SOIL:
      return '#8B4513';
    case SLIME_TYPES.TIME:
      return '#FFD700';
    default:
      return '#FFFFFF';
  }
};
